import React from 'react';
var functions = require("./functions.js");
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import db from './db.js';
var tableColumnRender = require("./TableColumnRender.js")

// HubSpotContactTable component
export default class HubSpotContactTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.hubSpotContactTableRef = React.createRef();
        let cols=[];
        try{
            cols.push({ key: 'display_contact_name', title:"Name" , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard});
            cols.push({ key: 'display_full_address', title:"Address", width:50 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} );
            cols.push({ key: 'display_phone', title : "Phone", width :20, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard});
            cols.push({ key: 'email', title:"EMail", width:30, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} );  
            cols.push({ key: 'jobtitle', title:"Job Title", editClassName:"hidden", width :40, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard });
            cols.push({ key: 'company', title : "Company", width :20, memo:true, noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard });  
            cols.push({ key: 'hubspot_contact_object_id', title:"Contact Id", width:10 ,  noedit:true, render:tableColumnRender.renderHubspotContactLink} );
            cols.push({ key: 'search_column', title:"Search", width:10 , noedit:true, noquery:true, doNotDisplayInTable:true} );
        } catch (ex){}        
        this.state={
            postObj:[],
            edited:false,
            selectedObject:false,
            contactList:[],
            columns:cols
        };

    }
    componentDidMount(prevProps) {
        this.queryData();
    }

    queryData(){
        db.getHubspotContacts(this.props.hubspotCompanyId, this.props.securityObject, (contactList) => {
            this.setState({
                contactList:contactList
            });
        });
    }
    // render
    render() {
        return (true)?(
            <div className='relative-div' key="hscDiv1">
                <div className="align-right">
                    <a target="new" href="https://community.hubspot.com/t5/Account-Settings/where-do-I-find-my-Hub-ID/m-p/647149#:~:text=To%20find%20your%20Hub%20ID,Hope%20this%20helps!">Hubspot Portal Id:</a>
                    <input id="HubSpotPortalId" className='search-table-input' onChange={this.updateHubspotPortalId.bind(this)} defaultValue={functions.getHubspotPortalId()}></input>
                    <a target="new" href="https://app.hubspot.com/">Hubspot</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a target="new" href="https://apps.goshippo.com/">shippo</a>
                </div>
                <TableScrollbar height="80vh">
                    <ErrorBoundary>
                        <Table
                            columns={this.state.columns}
                            dataSource={this.state.contactList} 
                        >
                        </Table>  
                    </ErrorBoundary>
                </TableScrollbar>

            </div>
        ):"";
    }

    // set the cookie to change the Bad Battery Threshold
    updateHubspotPortalId(e){
        this.setState({
            proxyPort:e.target.value
        })
        functions.saveCookieValue('HubspotPortalId',e.target.value)
    } 
}

